import { Component, Input } from '@angular/core';
import { OpportunityPriorityType } from '@wdx/clmi/clmi-swagger-gen';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-card-footer',
    templateUrl: './molecule-card-footer.component.html',
    standalone: false,
})
export class MoleculeCardFooterComponent {
    @Input() priority: OpportunityPriorityType;

    now: Date = new Date();

    readonly OPPORTUNITY_PRIORITY_TYPE = OpportunityPriorityType;
}
